// src/ExitIcon.tsx
import { jsx } from "react/jsx-runtime";
var ExitIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M15.6863 17.3828H2.46408C1.42088 17.3828 0.575195 16.5371 0.575195 15.4939V11.7161H2.46408V15.4939H15.6863V2.2717H2.46408V6.04948H0.575195V2.2717C0.575195 1.2285 1.42088 0.382812 2.46408 0.382812H15.6863C16.7295 0.382812 17.5752 1.2285 17.5752 2.2717V15.4939C17.5752 16.5371 16.7295 17.3828 15.6863 17.3828ZM8.13075 12.6606V9.82726H0.575195V7.93837H8.13075V5.10503L12.853 8.88281L8.13075 12.6606Z" })
  }
);

export {
  ExitIcon
};
